export type BiomassRecentRowLike = {
  lot?: string | null
  unmappedLot?: string | null
}

export const getBiomassRecentRowTitle = (
  row: BiomassRecentRowLike,
  fallbackLabel: string,
): string => {
  const lotLabel = String(row.lot ?? '').trim()
  if (lotLabel) return lotLabel

  const unmappedLabel = String(row.unmappedLot ?? '').trim()
  if (unmappedLabel) return `${fallbackLabel}: ${unmappedLabel}`

  return fallbackLabel
}
